import React, { useState } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { updateFirmInfoAction } from '../APIs/action';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import _, { set } from 'lodash';
const BasicDetailCard = ({ firmData, onRefresh = () => {} }) => {
  const [firm, setFirm] = useState(firmData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isBasicDetailEditing, setIsBasicDetailEditing] = useState(false);
  const handleBasicDetailEditClick = async (firm) => {
    const payload = {
      id: firm?.company_id,
      name: firm?.company_name,
    };
    if (isBasicDetailEditing) await onUpdate(payload);
    setIsBasicDetailEditing(!isBasicDetailEditing);
  };
  const handleBasicDetailDiscardClick = () => {
    setIsBasicDetailEditing(false);
    onRefresh();
  };
  const onUpdate = async (payload) => {
    const { data, error, message } = await updateFirmInfoAction(payload);
    if (!error) {
      toast.success('Request has been sent for approval');
      onRefresh();
    } else {
      onRefresh();
      return toast.error(message);
    }
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    const updatedFirm = _.cloneDeep(firm);
    const updateNestedProperty = (obj, path, value) => {
      const keys = path.split('.');
      let current = obj;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) current[keys[i]] = {};
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
    };
    updateNestedProperty(updatedFirm, name, value);
    setFirm(updatedFirm);
  };

  return (
    <Card sx={{ mt: '1rem' }}>
      <CardHeader
        title='Basic Detail'
        sx={{ backgroundColor: '#f5f5f5' }}
        action={
          <Stack
            direction='row'
            spacing={2}
          >
            <Tooltip title={isBasicDetailEditing ? 'Save' : 'Edit'}>
              <IconButton
                color='primary'
                onClick={() => handleBasicDetailEditClick(firm)}
              >
                {isBasicDetailEditing ? (
                  <CheckIcon sx={{ color: 'green' }} />
                ) : (
                  <EditIcon />
                )}
              </IconButton>
            </Tooltip>
            {isBasicDetailEditing && (
              <Tooltip title='Discard'>
                <IconButton
                  color='primary'
                  onClick={handleBasicDetailDiscardClick}
                >
                  <CloseIcon sx={{ color: 'red' }} />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        }
      />

      <CardContent>
        <Grid container>
          <Grid
            item
            xs={12}
            md={3.5}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Firm Type
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            alignContent='center'
          >
            <TextField
              disabled={true}
              label='Firm Type'
              name='firm_type'
              value={firm?.proprietorship_type}
              onChange={(event) => handleChange(event)}
              fullWidth
              margin='normal'
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            xs={12}
            md={3.5}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Firm Name
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            alignContent='center'
          >
            <TextField
              disabled={!isBasicDetailEditing}
              label='Firm Name'
              name='company_name'
              value={firm?.company_name}
              onChange={(event) => handleChange(event)}
              fullWidth
              margin='normal'
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            xs={12}
            md={3.5}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              GSTIN
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            alignContent='center'
          >
            <TextField
              disabled={true}
              label='GSTIN'
              name='company_gstin'
              value={firm?.company_gstin}
              onChange={(event) => handleChange(event)}
              fullWidth
              margin='normal'
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            xs={12}
            md={3.5}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              PAN
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            alignContent='center'
          >
            <TextField
              disabled={true}
              label='PAN'
              name='company_pan'
              value={firm?.company_pan}
              onChange={(event) => handleChange(event)}
              fullWidth
              margin='normal'
            />
          </Grid>
        </Grid>

        <Divider sx={{ mt: '3rem', mb: '1rem' }} />
      </CardContent>
    </Card>
  );
};

export default BasicDetailCard;
